import { observer } from "mobx-react";
import React from "react";
import TextInput from "../../../sharedComponents/textInput/textInput";
import { ValidatedValue } from "../../../../helpers/validator";

interface RaceProps {
    race: ValidatedValue<string>;
}

@observer
export default class Race extends React.Component<RaceProps> {

    public render() {
        return (
            <div className="field-container">
                <div className="label">Rasa</div>
                <TextInput
                    validatedValue={this.props.race}
                    topLabel="Rasa"
                />
            </div>);
    }
}
